import React, { useState } from "react";
import { jsPDF } from "jspdf";
import "./BuildingTypeForm.css";

const BuildingTypeForm = () => {
  const [form, setForm] = useState({
    buildingType: "",
    annualValue: ""
  });

  const [editId, setEditId] = useState(null);

  const [data, setData] = useState([
    { id: 1, buildingType: "आर. सी. सी.", annualValue: 500000 },
    { id: 2, buildingType: "इतर पक्के घर", annualValue: 350000 },
    { id: 3, buildingType: "अर्ध पक्के घर", annualValue: 200000 },
  ]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (!form.buildingType || !form.annualValue) {
      alert("सर्व माहिती भरणे आवश्यक आहे");
      return;
    }
    
    if (editId) {
      // Edit mode - update existing record
      setData(data.map((item) => 
        item.id === editId 
          ? { ...item, buildingType: form.buildingType, annualValue: form.annualValue }
          : item
      ));
      alert("माहिती सफलतेने अपडेट झाली! ✅");
      setEditId(null);
    } else {
      // Add new record
      setData([...data, { id: Date.now(), buildingType: form.buildingType, annualValue: form.annualValue }]);
      alert("माहिती यशस्वीरित्या जतन झाली! ✅");
    }
    
    setForm({ buildingType: "", annualValue: "" });
  };

  const handleReset = () => {
    setForm({ buildingType: "", annualValue: "" });
    setEditId(null);
  };

  const deleteData = (id) => {
    if (window.confirm("हटवायचं आहे का?")) {
      setData(data.filter((item) => item.id !== id));
      if (editId === id) {
        setEditId(null);
        setForm({ buildingType: "", annualValue: "" });
      }
    }
  };

  const editData = (item) => {
    setForm({ buildingType: item.buildingType, annualValue: item.annualValue });
    setEditId(item.id);
  };

  const generatePDF = async (specificId = null) => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      
      // Header
      pdf.setFillColor(79, 131, 163);
      pdf.rect(0, 0, pageWidth, 15, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(16);
      pdf.text("इमारतीच्या प्रकारानुसार वार्षिक मूल्य", pageWidth / 2, 10, { align: "center" });
      
      // Date
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(10);
      pdf.text(`तारीख: ${new Date().toLocaleDateString("en-GB")}`, 15, 25);
      
      // Get data to export
      const exportData = specificId 
        ? data.filter(item => item.id === specificId)
        : data;
      
      // Table data
      const tableData = exportData.map((item, index) => [
        index + 1,
        item.buildingType,
        `₹${item.annualValue.toLocaleString('en-IN')}`
      ]);
      
      // Add table
      pdf.autoTable({
        head: [["अ.क्र.", "इमारतीचा प्रकार", "वार्षिक मूल्य"]],
        body: tableData,
        startY: 32,
        theme: "grid",
        headStyles: {
          fillColor: [241, 244, 255],
          textColor: [44, 62, 80],
          fontStyle: "bold",
          fontSize: 11
        },
        bodyStyles: {
          textColor: [73, 80, 87],
          fontSize: 10
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250]
        }
      });
      
      // Footer
      const pageCount = pdf.internal.pages.length - 1;
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(128, 128, 128);
        pdf.text(`पृष्ठ ${i} / ${pageCount}`, pageWidth / 2, pdf.internal.pageSize.getHeight() - 10, { align: "center" });
      }
      
      // Save
      const fileName = specificId ? `इमारत-मूल्य-${specificId}.pdf` : `इमारत-मूल्य-यादी.pdf`;
      pdf.save(fileName);
    } catch (error) {
      alert("PDF तयार करताना त्रुटी: " + error.message);
    }
  };

  return (
    <div className="building-type-container">
      <div className="header">इमारतीच्या प्रकारानुसार वार्षिक मूल्य</div>

      <div className="wrapper">
        <div className="box">
          {editId && (
            <div className="edit-mode-banner">
              ✏️ संपादन मोड (ID: {editId})
            </div>
          )}
          <div className="field">
            <label>
              इमारतीचा प्रकार <span className="required">*</span>
            </label>
            <select
              name="buildingType"
              value={form.buildingType}
              onChange={handleChange}
            >
              <option value="">-- निवडा --</option>
              <option value="आर. सी. सी.">आर. सी. सी.</option>
              <option value="इतर पक्के घर">इतर पक्के घर</option>
              <option value="अर्ध पक्के घर">अर्ध पक्के घर</option>
              <option value="कच्चे घर">कच्चे घर</option>
            </select>
          </div>

          <div className="field">
            <label>
              वार्षिक मूल्य <span className="required">*</span>
            </label>
            <input
              type="number"
              name="annualValue"
              value={form.annualValue}
              onChange={handleChange}
              placeholder="मूल्य दाखल करा"
            />
          </div>

          <div className="btns">
            <button className="btn btn-save" onClick={handleSubmit}>
              जतन करा
            </button>
            <button className="btn btn-reset" onClick={handleReset}>
              रीसेट करा
            </button>
          </div>
        </div>
      </div>

      {/* Data Table */}
      <div className="table-container">
        <div className="table-header">
          <h3 className="table-title">इमारतीचा प्रकार यादी</h3>
          <div className="pdf-buttons">
            <button className="btn-pdf-all" onClick={() => generatePDF()}>
              📄 सर्व PDF
            </button>
            {data.length > 0 && (
              <button className="btn-pdf-specific" onClick={() => {
                if (editId) {
                  generatePDF(editId);
                } else {
                  alert("कृपया संपादित करायचा रेकॉर्ड निवडा");
                }
              }}>
                📋 विशिष्ट PDF
              </button>
            )}
          </div>
        </div>
        <table className="data-table">
          <thead>
            <tr>
              <th>अ.क्र.</th>
              <th>इमारतीचा प्रकार</th>
              <th>वार्षिक मूल्य</th>
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item.id} className={editId === item.id ? "edit-row" : ""}>
                  <td>{index + 1}</td>
                  <td>{item.buildingType}</td>
                  <td>₹{item.annualValue.toLocaleString('en-IN')}</td>
                  <td className="action-btns">
                    <button 
                      className="btn-edit"
                      onClick={() => editData(item)}
                    >
                      Edit
                    </button>
                    <button 
                      className="btn-delete"
                      onClick={() => deleteData(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="no-data">कोणती माहिती उपलब्ध नाही</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BuildingTypeForm;
